var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 3.33341H18.5807V5.00008H16.9141V17.5001C16.9141 17.7211 16.8263 17.9331 16.67 18.0893C16.5137 18.2456 16.3017 18.3334 16.0807 18.3334H4.41406C4.19305 18.3334 3.98109 18.2456 3.82481 18.0893C3.66853 17.9331 3.58073 17.7211 3.58073 17.5001V5.00008H1.91406V3.33341H6.08073V1.66675H14.4141V3.33341ZM7.7474 7.50008V14.1667H9.41406V7.50008H7.7474ZM11.0807 7.50008V14.1667H12.7474V7.50008H11.0807Z",
    fill: "#FB3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6c7f92be0044fe11c77fbb646c13f9df.svg";
export { ForwardRef as ReactComponent };